import ArtifactGroupType from "../base/ArtifactGroupType";


const WhispersOfTheInk = {
  id: '114',
  name: 'Whispers Of The Ink',
  groupIcon: 'WhispersOfJade',
  type: ArtifactGroupType.WHISPERS_OF_JADE,
  icon: 'WhispersOfTheInk',
  power: 25
};

export default WhispersOfTheInk;
